import { permissionObj } from '../../../Helpers/permission';

import HeadTittle from '../../../components/HeadTittle';
import ButtonAction from '../../../components/buttons/ButtonAction';
import {AddIcon, QrCodeIcon, TrashOutlineIconWhite} from '../../../components/buttons/IconButtons';
import { VisitorMainApp } from './Functionality/VisitorMainApp';
import StepperTabs from '../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../components/StepperTabs/StepTab';

import { Box } from '@mui/material';
import React from "react";
import VisitorTypeTable from "./Type/SubComponents/VisitorTypeTable";
import routes from "../../../Routes/routes";
import {TAB_PERMISSION_VISITOR, TABS_VISITOR} from "./Model/Model";
import InvitationMain from "./Invitation/InvitationMain";
import ExportDataBtn from "../../../components/buttons/ExportDataBtn";
import SearchFor from "../../Modals/SearchFor";
import SearchFilterBtn from "../../../components/buttons/SearchFilterBtn";
import {GetInvitationHeadersByOption, GetInvitationValuesByOptionFieldAndUserId
} from "../../../reduxToolkit/Invitation/InvitationApi";
import {VISITOR_SUB_VIEW_MODEL} from "./Invitation/Model/Model";
import {fieldModelKeyName} from "../../../enums/fieldModelEnum";
import CreateVisitorModal from "./Modal/CreateVisitorModal";
import DeleteModal from "../../Modals/DeleteModal";
import VisitorRequestMain from "./Request/VisitorRequestMain";
import VisitorTabMain from './Visitor/VisitorTabMain';
import {handleDownloadQR} from "./Guard/Model/Model";
import {MODELS} from "../../../Apis/Models";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 * @returns {JSX.Element}
 * @constructor
 */

const VisitorMain = () => {
    const {
        t,
        DEV,
        dispatch,
        userId,
        permission,
        navigate,
        steps,
        activeStep,
        setActiveStep,
        setDeleteModal,
        deleteModal,
        selectedList,
        setSelectedList,
        subView,
        setSubView,
        search,
        setSearch,
        moduleId,
        criteria,
        setCriteria,
        option,
        bodyForExport,
        setBodyForExport,
        searchElement,
        setSearchElement,
        finalArray,
        setFinalArray,
        filterDialogShow,
        setFilterDialogShow,
        modified,
        setModified,
        showVisitorModal,
        setShowVisitorModal,
        handleStepChange,
        goCreate,
        permissionButtons,
        deleteSelected,
        setOption,
        setModuleId,
        viewOrigin,
        isAllChecked,
        setIsAllChecked,
        simpleSearch,
        setSimpleSearch
    } = VisitorMainApp();

    if( !DEV &&
        !permission?.includes(permissionObj?.WEB_VISITOR_INVITATION_READ) &&
        !permission?.includes(permissionObj?.WEB_VISITOR_REQUEST_READ) &&
        !permission?.includes(permissionObj?.WEB_VISITOR_READ) &&
        !permission?.includes(permissionObj?.WEB_VISITOR_TYPE_READ) &&
        !permission?.includes(permissionObj?.WEB_REQUEST_ACCESS_READ)
    ) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'visitor_management'}>
                <Box className='d-flex gap-2 justify-content-end align-items-center mb-2'>
                    {permissionButtons(TAB_PERMISSION_VISITOR(subView).QR_REQUEST_ACCESS) &&
                        <ButtonAction
                            id='btn_vm_generate_qr'
                            name={'generate_qr'}
                            className='btn-icon-accent-450'
                            Icon={QrCodeIcon}
                            splitName={false}
                            onClick={() => handleDownloadQR(dispatch)}
                        />
                    }

                    {permissionButtons(TAB_PERMISSION_VISITOR(subView).EXPORT) && <>
                        {
                            search ? (
                                <ExportDataBtn
                                    id="btn_fm_export"
                                    moduleId={moduleId}
                                    body={criteria}
                                    search={search}
                                    option={option}
                                    callApi={[TABS_VISITOR.INVITATIONS.INDEX, TABS_VISITOR.REQUESTS.INDEX].includes(activeStep) ?
                                        () => dispatch(GetInvitationHeadersByOption(subView))
                                        : null
                                    }
                                />
                            ) : (
                                <ExportDataBtn
                                    id="btn_fm_export"
                                    moduleId={moduleId}
                                    body={bodyForExport}
                                    option={option}
                                    search={search}
                                    searchElement={searchElement}
                                    callApi={[TABS_VISITOR.INVITATIONS.INDEX, TABS_VISITOR.REQUESTS.INDEX].includes(activeStep)  ?
                                        () => dispatch(GetInvitationHeadersByOption(subView))
                                        : null
                                    }
                                />
                            )
                        }
                    </>
                    }

                    {permissionButtons(TAB_PERMISSION_VISITOR(subView).CREATE) && (
                        <ButtonAction
                            id='btn_d_add'
                            name={ 'create'}
                            className='btn-icon-add'
                            Icon={AddIcon}
                            onClick={goCreate}
                        />
                    )}
                    {permissionButtons(TAB_PERMISSION_VISITOR(subView).DELETE) && (
                        <ButtonAction
                            id='btn_vti_delete'
                            name='delete'
                            className='btn-icon-delete'
                            disabled={selectedList?.length === 0}
                            Icon={TrashOutlineIconWhite}
                            onClick={() => {
                                setDeleteModal(true);
                            }}
                        />
                    )}
                    {permissionButtons(TAB_PERMISSION_VISITOR(subView).ADVANCE_SEARCH) && (
                        <SearchFilterBtn finalArray={finalArray} fnclick={() => setFilterDialogShow(true)} />

                    )}
                </Box>
            </HeadTittle>

            <StepperTabs
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_VISITOR.INVITATIONS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_VISITOR.INVITATIONS.INDEX &&
                        <InvitationMain
                            subView={subView}
                            setSubView={setSubView}
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            criteria={criteria}
                            setCriteria={setCriteria}
                            setBodyForExport={setBodyForExport}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            finalArray={finalArray}
                            setFinalArray={setFinalArray}
                            search={search}
                            setSearch={setSearch}
                            modified={modified}
                            setModified={setModified}
                        />
                    }
                </StepTab>
                <StepTab index={TABS_VISITOR.REQUESTS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_VISITOR.REQUESTS.INDEX &&(
                        <VisitorRequestMain
                            subView={subView}
                            setSubView={setSubView}
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            criteria={criteria}
                            setCriteria={setCriteria}
                            setBodyForExport={setBodyForExport}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            finalArray={finalArray}
                            setFinalArray={setFinalArray}
                            search={search}
                            setSearch={setSearch}
                            setOption={setOption}
                            setModuleId={setModuleId}
                            modified={modified}
                            setModified={setModified}
                        />
                    )}
                </StepTab>
                <StepTab index={TABS_VISITOR.VISITORS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_VISITOR.VISITORS.INDEX &&
                        <VisitorTabMain
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            setCriteria={setCriteria}
                            setBodyForExport={setBodyForExport}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            finalArray={finalArray}
                            setFinalArray={setFinalArray}
                            search={search}
                            setSearch={setSearch}
                            deleteModal={deleteModal}
                            setDeleteModal={setDeleteModal}
                            modified={modified}
                            setModified={setModified}
                            setShowVisitorModal={setShowVisitorModal}
                            viewOrigin={viewOrigin}
                            subView={subView}
                            setSubView={setSubView}
                            activeStep={activeStep}
                            isAllChecked={isAllChecked}
                            setIsAllChecked={setIsAllChecked}
                            simpleSearch={simpleSearch}
                            setSimpleSearch={setSimpleSearch}
                        />
                    }
                </StepTab>
                <StepTab index={TABS_VISITOR.TYPES.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === TABS_VISITOR.TYPES.INDEX &&
                    <VisitorTypeTable
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        modified={modified}
                        setModified={setModified}
                        setDeleteModal={setDeleteModal}
                    />
                    }
                </StepTab>
            </StepperTabs>
            {(filterDialogShow || finalArray?.length > 0) &&
                <SearchFor
                    open={filterDialogShow}
                    onClose={() => {
                        setFilterDialogShow(false);
                    }}
                    onFiltered={(originalArray) => {
                        setFilterDialogShow(false);
                        setFinalArray(originalArray);
                        setSearchElement(''); // Clear search input after filtering
                    }}
                    moduleId={moduleId}
                    option={option}
                    finalArray={finalArray}
                    setSearch={setSearch}
                    cleanAdvance={modified}
                    setCleanAdvance={setModified}
                    setFinalArray={setFinalArray} // Used to reset filters
                    searchElement={searchElement} // Track input changes
                    userId={activeStep === TABS_VISITOR.INVITATIONS.INDEX ? userId : null}
                    noShowFilters={subView === VISITOR_SUB_VIEW_MODEL.INVITATION.ONGOING ?
                        [fieldModelKeyName.host]
                        : subView === VISITOR_SUB_VIEW_MODEL.INVITATION.INCOMING ?
                            [fieldModelKeyName.visitor, fieldModelKeyName.visitorNumber, fieldModelKeyName.visitorType, fieldModelKeyName.approvalStatus]
                            : subView === VISITOR_SUB_VIEW_MODEL.REQUESTS.REQUESTED_INVITATIONS ?
                                [fieldModelKeyName.identityValidation, fieldModelKeyName.identityValidationType]
                                : null
                    }
                    callGetValuesApi={activeStep === TABS_VISITOR.INVITATIONS.INDEX ?
                        ({fieldName}) => dispatch(GetInvitationValuesByOptionFieldAndUserId({
                            field: fieldName,
                            viewType: subView,
                            userId
                        }))
                        : null
                    }
                />
            }
            <CreateVisitorModal
                title={t('create_visitor')}
                show={showVisitorModal}
                onHide={() => setShowVisitorModal(false)}
                modified={modified}
                setModified={setModified}
                moduleId={MODELS.VISITOR}
            />

            <DeleteModal
                show={deleteModal}
                onHide={() => setDeleteModal(false)}
                data={selectedList}
                onClickFn={() => {
                    deleteSelected(selectedList);
                    setDeleteModal(false);
                }}
                title_modal={activeStep === TABS_VISITOR.VISITORS.INDEX ?
                    "delete_visitors":
                    activeStep === TABS_VISITOR.TYPES.INDEX ?
                    "delete_visitor_type"
                        : ""
                }
                element_modal={activeStep === TABS_VISITOR.VISITORS.INDEX ?
                    "visitors":
                    activeStep === TABS_VISITOR.TYPES.INDEX ?
                        "visitor_type"
                        : ""
                }
                isReset={() => setSelectedList([])}
                isAllReset={setIsAllChecked}
            />
        </>
    );
};

export default VisitorMain;
